import type { SVGProps } from 'react';

const SvgMore = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox='0 0 24 24' fill='none' width='1em' height='1em' focusable='false' color='currentColor' {...props}>
    <path
      d='M10 5C10 5.9665 10.7835 6.75 11.75 6.75C12.7165 6.75 13.5 5.9665 13.5 5C13.5 4.0335 12.7165 3.25 11.75 3.25C10.7835 3.25 10 4.0335 10 5Z'
      fill='currentColor'
    />
    <path
      d='M10 12C10 12.9665 10.7835 13.75 11.75 13.75C12.7165 13.75 13.5 12.9665 13.5 12C13.5 11.0335 12.7165 10.25 11.75 10.25C10.7835 10.25 10 11.0335 10 12Z'
      fill='currentColor'
    />
    <path
      d='M10 19C10 19.9665 10.7835 20.75 11.75 20.75C12.7165 20.75 13.5 19.9665 13.5 19C13.5 18.0335 12.7165 17.25 11.75 17.25C10.7835 17.25 10 18.0335 10 19Z'
      fill='currentColor'
    />
  </svg>
);
export default SvgMore;
